import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import {
  Autocomplete,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  TextareaAutosize,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Navigate } from "react-router-dom";
import init from "Helpers/WindowToken";

export default class AddCourses extends Component {
  state = {
    course_name: "",
    duration: "",
    course_mode: "offline", // default
    price: "",
    description: "",
    course_image: null,
    rating: "",
    loading: false,
    notification: false,
    message: "",
    redirect: false,
    course_type: "abacus",
  };

  componentDidMount() {
    // optionally fetch reference data if needed
    if (init() !== "success") {
      window.location.assign("/signin");
    }
  }

  handleInput = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      this.setState({ [name]: files[0] });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleDescription = (content) => {
    this.setState({ description: content });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    // build fresh FormData per submit
    const fd = new FormData();
    fd.append("course_name", this.state.course_name);
    fd.append("duration", this.state.duration);
    fd.append("course_mode", this.state.course_mode);
    fd.append("course_type", this.state.course_type);
    fd.append("price", this.state.price || 0);
    fd.append("description", this.state.description || "");
    if (this.state.course_image) fd.append("course_image", this.state.course_image);
    if (this.state.rating) fd.append("rating", this.state.rating);

    if (init() !== "success") {
      // session expired / not logged in
      window.location.assign("/signin");
      return;
    }

    this.setState({ loading: true });

    try {
      // adjust endpoint name if your Constants object uses a different key
      const resp = await axios.post(Constants.postUrls.addNewCourse, fd);

      //   fd.delete();
      this.setState({
        notification: true,
        message: resp.data.message || "Course created",
      });

      setTimeout(() => {
        this.setState({ notification: false, message: "", redirect: true });
      }, 2000);
    } catch (err) {
      console.error(err);
      this.setState({
        notification: true,
        message: err?.response?.data?.message || err.message || "Error creating course",
        loading: false,
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 4000);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/courses" />;
    }

    return (
      <div>
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Create Course
                </MDTypography>
              </MDBox>

              <MDBox py={3} px={2}>
                <form onSubmit={this.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item sm={6}>
                      <TextField
                        type="text"
                        label="Course Name"
                        name="course_name"
                        value={this.state.course_name}
                        onChange={this.handleInput}
                        required
                        fullWidth
                      />
                    </Grid>

                    <Grid item sm={6}>
                      <TextField
                        type="text"
                        label="Duration (e.g. 3 months)"
                        name="duration"
                        value={this.state.duration}
                        onChange={this.handleInput}
                        fullWidth
                      />
                    </Grid>

                    <Grid item sm={4}>
                      <InputLabel>Select Course Mode</InputLabel>
                      <Select
                        value={this.state.course_mode}
                        onChange={(e) => this.setState({ course_mode: e.target.value })}
                        name="course_mode"
                        required
                        fullWidth
                        style={{ height: "45px", color: "#111" }}
                      >
                        <MenuItem value="online">Online</MenuItem>
                        <MenuItem value="offline">Offline</MenuItem>
                        <MenuItem value="hybrid">Hybrid</MenuItem>
                      </Select>
                    </Grid>

                    <Grid item sm={4}>
                      <InputLabel>Select Course Tyoe</InputLabel>
                      <Select
                        value={this.state.course_type}
                        onChange={(e) => this.setState({ course_type: e.target.value })}
                        name="course_type"
                        required
                        fullWidth
                        style={{ height: "45px", color: "#111" }}
                      >
                        <MenuItem value="abacus">Abacus</MenuItem>
                        <MenuItem value="kalfun">Kalfun</MenuItem>
                        <MenuItem value="vedic_maths">Vedic Maths</MenuItem>
                      </Select>
                    </Grid>

                    <Grid item sm={4}>
                      <TextField
                        type="number"
                        label="Price"
                        name="price"
                        value={this.state.price}
                        onChange={this.handleInput}
                        fullWidth
                        inputProps={{ min: 0 }}
                      />
                    </Grid>

                    <Grid item sm={4}>
                      <TextField
                        type="number"
                        label="Rating (0-5)"
                        name="rating"
                        value={this.state.rating}
                        onChange={this.handleInput}
                        fullWidth
                        inputProps={{ min: 0, max: 5, step: 0.1 }}
                      />
                    </Grid>

                    <Grid item sm={6}>
                      <TextField
                        type="file"
                        label="Course Image"
                        name="course_image"
                        onChange={this.handleInput}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>

                    <Grid item sm={12}>
                      <InputLabel>Course Description</InputLabel>
                      <SunEditor
                        setDefaultStyle="font-family: Arial; font-size: 16px;"
                        setOptions={{
                          buttonList: [
                            ["undo", "redo"],
                            ["font", "fontSize"],
                            ["paragraphStyle", "blockquote"],
                            ["bold", "underline", "italic", "strike"],
                            ["fontColor", "hiliteColor"],
                            ["align", "list", "lineHeight"],
                            ["outdent", "indent"],
                            ["table", "horizontalRule", "link", "image", "video"],
                            ["imageGallery"],
                            ["preview", "print"],
                            ["removeFormat"],
                          ],
                          defaultTag: "div",
                          height: 200,
                          showPathLabel: false,
                        }}
                        name="description"
                        setContents={this.state.description}
                        onChange={this.handleDescription}
                      />
                    </Grid>
                  </Grid>

                  <Grid align="left" mt={2} style={{ marginTop: 16 }}>
                    <MDButton variant="contained" size="small" color="info" type="submit">
                      {this.state.loading ? "Creating..." : "Create"}
                    </MDButton>
                  </Grid>
                </form>
              </MDBox>

              <MDSnackbar
                color="success"
                icon="notifications"
                title="VASA | Courses"
                content={this.state.message}
                dateTime="Just now"
                open={this.state.notification}
              />
            </Card>
          </MDBox>
        </DashboardLayout>
      </div>
    );
  }
}
